import { Tabs } from "antd";
import React, { useEffect } from "react";
import Inbox from "./Inbox";
import Outbox from "./Outbox";
import { useTranslation } from "react-i18next";
import { HomeOutlined } from "@ant-design/icons";
import { useBreadcrumbs } from "../../../context/breadcrumbs";

export default function NotificationContent(): React.ReactNode | null {
  const { setBreadcrumbs } = useBreadcrumbs();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    setBreadcrumbs([
      { title: <HomeOutlined />, href: "/" },
      { title: t("routes.notificationCentre") },
    ]);
  }, [i18n.language, t]);
  const items = [
    {
      key: "1",
      label: t("pages.notificationCenter.inbox"),
      children: <Inbox />,
    },
    {
      key: "2",
      label: t("pages.notificationCenter.outbox"),
      children: <Outbox />,
    },
  ];

  return (
    <div style={{ background: "none" }}>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
}
